import { Box, Stack, Typography } from "@mui/material";
import { useMemo } from "react";
import { Link } from "react-router-dom";

import { Product } from "api/memberPortal/project/product/product.types";
import { useGetGroupedPpsQuery } from "api/memberPortal/project/protectionProfiles/protectionProfiles.api";

interface PpClaimCellProps {
  product: Product;
}

const PpClaimCell = ({ product: { product_id } }: PpClaimCellProps) => {
  const { data: groupedPps } = useGetGroupedPpsQuery();

  const productPps = useMemo(() => {
    if (!groupedPps) return [];

    const pps = groupedPps[product_id];
    if (!pps) return [];

    return [...pps].sort((a, b) =>
      a.pp_short_name.localeCompare(b.pp_short_name),
    );
  }, [groupedPps, product_id]);

  return (
    <Stack gap={0.2} height="100%" justifyContent="center" width="100%">
      {productPps.map((pp) => (
        <Link to={`/community/protectionprofiles/details/${pp.id}`} key={pp.id}>
          <Box
            sx={{
              background: "white",
              px: 1.5,
              py: 0.75,
              width: "100%",
              border: "solid lightgrey 1px",
            }}
          >
            <Typography
              fontSize={12}
              color="text.primary"
              whiteSpace="nowrap"
              textOverflow="ellipsis"
              overflow="hidden"
            >
              {pp.pp_short_name}
            </Typography>
          </Box>
        </Link>
      ))}
    </Stack>
  );
};

export default PpClaimCell;
